// @flow

import { useGoogleAnalyticsIdentify } from './google'
import { useOpenPanelIdentify } from './openPanel'

export const useAnalyticsIdentify = (userId: string, options: Object = {}) => {
  useGoogleAnalyticsIdentify(userId, options)
  useOpenPanelIdentify(userId, options)
}

export default useAnalyticsIdentify
